var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\n\tCECI EST LE DIV DOCUMENT "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n\n\tOUI OUI DOCUMENTS "),_c('br'),_vm._v(" "),_c('button',{on:{"click":_vm.goback}},[_vm._v("Fermer")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40071acd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Immatriculation/Documents_immat.vue
// module id = null
// module chunks = 